<p-breadcrumb [model]="items"></p-breadcrumb>
<div class="topBarWrapper">
  <h1 class="heading-text">Configuration Profile for <span>{{configData?.profileName}} ({{accountId}})</span></h1>
  <ng-container *hasPermission="editConfigPermissions">
    <a class="button  editAction" *ngIf="configData?.accountStatus && !isRaAccount"
      [routerLink]="['/config/configuration/account',accountId,'config',configId,'edit']">Edit</a>
  </ng-container>
  <span *ngIf="configData?.accountStatus === false" class="notification">Account is Inactive</span>
</div>
<div class="setupDetailWrapper">
  <div class="configureField">
    <div class="setup-section">
      <div class="fieldWrapper">
        <span class="col-sm-4 col-form-label">Profile Name:</span>
        <div class="value">
          {{configData?.profileName}}
        </div>
      </div>

      <div class="fieldWrapper">
        <span class="col-sm-4 col-form-label">Description / Note: </span>
        <div class="control-wrapper descriptionNote">
          {{configData?.descriptionNote || 'NA'}}
        </div>
      </div>

      <div class="fieldWrapper">
        <span class="col-sm-4 col-form-label">Monitoring Enabled:</span>
        <div class="value">
          {{configData?.monitoringEnabled ? 'Yes' : 'No'}}
        </div>
      </div>

      <div class="fieldWrapper">
        <span class="col-sm-4 col-form-label">Default Config:</span>
        <div class="value">
          {{configData?.defaultConfig ? 'Yes' : 'No'}}
        </div>
      </div>

      <div class="fieldWrapper">
        <span class="col-sm-4 col-form-label">Screening Vendor:</span>
        <div class="value">
          {{configData?.screeningVendor}}
        </div>
      </div>
    </div>
    <div class="additionalField profileStatus">
      <div class="fieldWrapper">
        <span class="col-sm-4 col-form-label">RPS Config ID:</span>
        <div class="value">
          {{configData?.rpsConfigId}}
        </div>
      </div>
      <div class="fieldWrapper">
        <span class="col-sm-4 col-form-label">Status:</span>
        <div class="value configStatus {{configData?.configurationStatus}}">
          {{configData?.configurationStatus}}
        </div>
      </div>
      <div class="fieldWrapper">
        <span class="col-sm-4 col-form-label">Custom List:</span>
        <div class="value">
          {{configData?.customListEnabled ? 'Yes' : 'No'}}
        </div>
      </div>
      <div class="fieldWrapper" *ngIf="ifUser">
        <span class="col-sm-4 col-form-label">WLS Split Enable:</span>
        <div class="value configStatus">
          <input type="checkbox" [checked]="is_WLS_Enable" (change)="changed($event)" id="no" />
        </div>
      </div>

    </div>
  </div>
  <div class="tabLayout-wrapper" *ngIf="watchList_sanc.code || watchLists.code">
    <p-tabView>
      <p-tabPanel header="Watchlists & Sanctions" *ngIf="watchList_sanc.code && is_WLS_Enable === false">
        <div>
          <div class="setup-section">
            <ng-container *ngIf="watchList_sanc.customListOptions?.customListEnabled === true">
              <div class="fieldWrapper">
                <span class="col-sm-4 col-form-label">Custom List Enabled: </span>
                <div class="value">
                  {{watchList_sanc.customListOptions?.customListEnabled ? 'Yes' : 'No'}}
                </div>
              </div>
              <div class="fieldWrapper">
                <span class="col-sm-4 col-form-label">List Name:</span>
                <div class="value">{{watchList_sanc.customListOptions?.customListFileName}}</div>
              </div>
              <div class="fieldWrapper">
                <span class="col-sm-4 col-form-label">Custom List File:</span>
                <div class="value"><a href="" class="link"
                    (click)="exportSourceListAsCsv(sourceList_watch_sanc, watchList_sanc?.customListOptions?.customListFileName || 'export.csv'); $event.preventDefault()">Download Link</a></div>
              </div>
            </ng-container>
            <ng-container *ngIf="watchList_sanc.customListOptions?.customListEnabled === false">
              <div class="fieldWrapper">
                <span class="col-sm-4 col-form-label">Time Frame for Searches: </span>
                <div class="value">
                  {{watchList_sanc.selectedTimeFrame?.description}}
                </div>
              </div>
              <div class="fieldWrapper" *ngIf="watchList_sanc?.customListOptions?.customListEnabled">
                <span class="col-sm-4 col-form-label">Custome List ID: </span>
                <div class="value">
                  {{watchList_sanc.customListId || 'NA'}}
                </div>
              </div>
              <div class="form-group categoryControl">
                <span class="col-form-label">Product Categories: </span>
                <div class="value">
                  <div class="categoryWrapper">
                    <div class="category" *ngFor="let category of watchList_sanc.categories;">
                      <div class="parent">
                        <span class="pi" [ngClass]="category.show ? 'pi-angle-down' : 'pi-angle-right'"
                          (click)="category.show=!category.show"></span>
                        {{category.code}}
                      </div>
                      <div *ngIf="category.show">
                        <div class="options" *ngFor="let option of category.options">
                          <input type="checkbox" class="custom" [checked]="option.selected" disabled>
                          {{option.description}}
                        </div>
                      </div>
                    </div>
                  </div><!-- categoryWrapper -->
                </div>
              </div>
              <div class="form-group categoryControl">
                <span class="col-form-label">Sub Categories: </span>
                <div class="value">
                  <div class="subCategoryWrapper">
                    <div class="fieldWrapper" *ngFor="let choice of watchList_sanc.subProducts; let i=index">
                      <input type="checkbox" class="custom" [checked]="choice.selected" disabled>
                      <span>
                        {{choice.description}}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
          <div class="sourceList table-responsive" *ngIf="sourceList_watch_sanc?.length">
                <p-table #dt1 [value]="sourceList_watch_sanc" dataKey="id" [rows]="10" [resizableColumns]="false" [autoLayout]="true" responsiveLayout="scroll" scrollHeight="400px" [rowHover]="true">
                  <ng-template pTemplate="caption">
                    <div class="p-d-flex">
                      <span class="p-input-icon-left p-ml-auto">
                      <a href="" class="link" (click)="showAddSourceModal('watchList_sanc', watchList_sanc.customListId || ''); $event.preventDefault()">Add source to Custom List</a>
                      </span>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="header">
                    <tr>
                      <th>ID</th>
                      <th>Source Id</th>
                      <th>Name</th>
                      <th>Agency</th>
                      <th>Remove</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-source>
                    <tr>
                      <td>{{source.customListSourceId}}</td>
                      <td>{{source.sourceId}}</td>
                      <td>{{source.sourceName}}</td>
                      <td>{{source.sourceAgency}}</td>
                      <td><a class="reactive" (click)="removeSource(source.customListSourceId, source.customListId, 'watchList_sanc')" href="javascript:void(0)"><i class="pi pi-times"></i></a></td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
        </div>
      </p-tabPanel>
      <p-tabPanel header="Sanctions" *ngIf="sanctions.code && is_WLS_Enable === true">
        <div>
          <div class="setup-section">
            <ng-container *ngIf="sanctions.customListOptions?.customListEnabled === true">
              <div class="fieldWrapper">
                <span class="col-sm-4 col-form-label">Custom List Enabled: </span>
                <div class="value">
                  {{sanctions.customListOptions?.customListEnabled ? 'Yes' : 'No'}}
                </div>
              </div>
              <div class="fieldWrapper">
                <span class="col-sm-4 col-form-label">List Name:</span>
                <div class="value">{{sanctions.customListOptions?.customListFileName}}</div>
              </div>
              <div class="fieldWrapper">
                <span class="col-sm-4 col-form-label">Custom List File:</span>
                <div class="value"><a href="" class="link"
                    (click)="exportSourceListAsCsv(sourceList_sanc, sanctions?.customListOptions?.customListFileName || 'export.csv'); $event.preventDefault()">Download Link</a></div>
              </div>
              
            </ng-container>
            <ng-container *ngIf="sanctions.customListOptions?.customListEnabled === false">
              <div class="fieldWrapper" *ngIf="!isDiligent">
                <span class="col-sm-4 col-form-label">Time Frame for Searches: </span>
                <div class="value">
                  {{sanctions.selectedTimeFrame?.description}}
                </div>
              </div>
              <div class="fieldWrapper" *ngIf="sanctions?.customListOptions?.customListEnabled">
                <span class="col-sm-4 col-form-label">Custome List ID: </span>
                <div class="value">
                  {{sanctions.customListId || 'NA'}}
                </div>
              </div>
              <div class="form-group categoryControl">
                <span class="col-form-label">Product Categories: </span>
                <div class="value">
                  <div class="categoryWrapper">
                    <div class="category" *ngFor="let category of sanctions.categories;">
                      <div class="parent">
                        <span class="pi" [ngClass]="category.show ? 'pi-angle-down' : 'pi-angle-right'"
                          (click)="category.show=!category.show"></span>
                        {{category.code}}
                      </div>
                      <div *ngIf="category.show">
                        <div class="options" *ngFor="let option of category.options">
                          <input type="checkbox" class="custom" [checked]="option.selected" disabled>
                          {{option.description}}
                        </div>
                      </div>
                    </div>
                  </div><!-- categoryWrapper -->
                </div>
              </div>
              <!-- <div class="form-group categoryControl">
              <span class="col-form-label">Sub Categories: </span>
              <div class="value">
                <div class="subCategoryWrapper">
                  <div class="fieldWrapper" *ngFor="let choice of sanctions.subProducts; let i=index">
                    <input type="checkbox" class="custom" [checked]="choice.selected" disabled>
                    <span>
                      {{choice.description}}
                    </span>
                  </div>
                </div>
              </div>
            </div> -->
            </ng-container>
          </div>
          <div class="sourceList table-responsive" *ngIf="sourceList_sanc?.length">
                <p-table #dt1 [value]="sourceList_sanc" dataKey="id" [rows]="10" [resizableColumns]="false" [autoLayout]="true" responsiveLayout="scroll" scrollHeight="400px" [rowHover]="true">
                  <ng-template pTemplate="caption">
                    <div class="p-d-flex">
                      <span class="p-input-icon-left p-ml-auto">
                      <a href="" class="link" (click)="showAddSourceModal('sanctions', sanctions.customListId || ''); $event.preventDefault()">Add source to Custom List</a>
                      </span>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="header">
                    <tr>
                      <th>ID</th>
                      <th>Source Id</th>
                      <th>Name</th>
                      <th>Agency</th>
                      <th>Remove</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-source>
                    <tr>
                      <td>{{source.customListSourceId}}</td>
                      <td>{{source.sourceId}}</td>
                      <td>{{source.sourceName}}</td>
                      <td>{{source.sourceAgency}}</td>
                      <td><a class="reactive" (click)="removeSource(source.customListSourceId, source.customListId, 'sanctions')" href="javascript:void(0)"><i class="pi pi-times"></i></a></td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
        </div>
      </p-tabPanel>
      <p-tabPanel header="Watchlists" *ngIf="watchLists.code  && is_WLS_Enable === true">

        <div>
          <div class="setup-section">
            <ng-container *ngIf="watchLists.customListOptions?.customListEnabled === true">
              <div class="fieldWrapper">
                <span class="col-sm-4 col-form-label">Custom List Enabled: </span>
                <div class="value">
                  {{watchLists.customListOptions?.customListEnabled ? 'Yes' : 'No'}}
                </div>
              </div>
              <div class="fieldWrapper">
                <span class="col-sm-4 col-form-label">List Name:</span>
                <div class="value">{{watchLists.customListOptions?.customListFileName}}</div>
              </div>
              <div class="fieldWrapper">
                <span class="col-sm-4 col-form-label">Custom List File:</span>
                <div class="value"><a href="" class="link"
                    (click)="exportSourceListAsCsv(sourceList_watch, watchLists.customListOptions?.customListFileName || 'export.csv'); $event.preventDefault()">Download Link</a></div>
              </div>
            </ng-container>
            <ng-container *ngIf="watchLists.customListOptions?.customListEnabled === false">
              <div class="fieldWrapper" *ngIf="!isDiligent">
                <span class="col-sm-4 col-form-label">Time Frame for Searches: </span>
                <div class="value">
                  {{watchLists.selectedTimeFrame?.description}}
                </div>
              </div>
              <div class="fieldWrapper" *ngIf="watchLists?.customListOptions?.customListEnabled">
                <span class="col-sm-4 col-form-label">Custome List ID: </span>
                <div class="value">
                  {{watchLists.customListId || 'NA'}}
                </div>
              </div>
              <div class="form-group categoryControl">
                <span class="col-form-label">Product Categories: </span>
                <div class="value">
                  <div class="categoryWrapper">
                    <div class="category" *ngFor="let category of watchLists.categories;">
                      <div class="parent">
                        <span class="pi" [ngClass]="category.show ? 'pi-angle-down' : 'pi-angle-right'"
                          (click)="category.show=!category.show"></span>
                        {{category.code}}
                      </div>
                      <div *ngIf="category.show">
                        <div class="options" *ngFor="let option of category.options">
                          <input type="checkbox" class="custom" [checked]="option.selected" disabled>
                          {{option.description}}
                        </div>
                      </div>
                    </div>
                  </div><!-- categoryWrapper -->
                </div>
              </div>
              <!-- <div class="form-group categoryControl">
                    <span class="col-form-label">Sub Categories: </span>
                    <div class="value">
                      <div class="subCategoryWrapper">
                        <div class="fieldWrapper" *ngFor="let choice of watchLists.subProducts; let i=index">
                          <input type="checkbox" class="custom" [checked]="choice.selected" disabled>
                          <span>
                            {{choice.description}}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div> -->
            </ng-container>
            
          </div>
          <div class="sourceList table-responsive" *ngIf="sourceList_watch?.length">
                <p-table #dt1 [value]="sourceList_watch" dataKey="id" [rows]="10" [resizableColumns]="false" [autoLayout]="true" responsiveLayout="scroll" scrollHeight="400px" [rowHover]="true">
                  <ng-template pTemplate="caption">
                    <div class="p-d-flex">
                      <span class="p-input-icon-left p-ml-auto">
                      <a href="" class="link" (click)="showAddSourceModal('watchLists', watchLists.customListId || ''); $event.preventDefault()">Add source to Custom List</a>
                      </span>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="header">
                    <tr>
                      <th>ID</th>
                      <th>Source Id</th>
                      <th>Name</th>
                      <th>Agency</th>
                      <th>Remove</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-source>
                    <tr>
                      <td>{{source.customListSourceId}}</td>
                      <td>{{source.sourceId}}</td>
                      <td>{{source.sourceName}}</td>
                      <td>{{source.sourceAgency}}</td>
                      <td><a class="reactive" (click)="removeSource(source.customListSourceId, source.customListId, 'watchLists')" href="javascript:void(0)"><i class="pi pi-times"></i></a></td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
        </div>
      </p-tabPanel>
      <p-tabPanel header="Political Exposure" *ngIf="political?.code">
        <div>
          <div class="setup-section">
            <div class="form-group categoryControl">
              <span class="col-form-label">PEPDesk Categories: </span>
              <div class="value">
                <div class="categoryWrapper">
                  <div class="category" *ngFor="let category of political.categories">
                    <div class="parent">
                      <input type="checkbox" class="custom" [checked]="category.selected" disabled>
                      {{category.description}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group categoryControl">
              <span class="col-form-label">Sub Categories: </span>
              <div class="value">
                <div class="subCategoryWrapper">
                  <div class="fieldWrapper" *ngFor="let choice of political.subProducts; let i=index">
                    <input type="checkbox" class="custom" [checked]="choice.selected" disabled>
                    <span>
                      {{choice.description}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </p-tabPanel>
      <p-tabPanel header="Diligent SOE" *ngIf="diligentSOE?.code">
        <div>
          <div class="setup-section">
            <div class="form-group categoryControl">
              <span class="col-form-label">Diligent SOE Categories: </span>
              <div class="value">
                <div class="categoryWrapper">
                  <div class="category" *ngFor="let category of diligentSOE.categories">
                    <div class="parent">
                      <input type="checkbox" class="custom" [checked]="category.selected" disabled>
                      {{category.description}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </p-tabPanel>
      <p-tabPanel header="Adverse Media" *ngIf="adverseMedia?.code">
        <div>
          <div class="setup-section">
            <div class="fieldWrapper">
              <span class="col-sm-4 col-form-label">Time Frame for Searches: </span>
              <div class="value">
                {{adverseMedia.selectedTimeFrame?.description}}
              </div>
            </div>
            <div class="form-group categoryControl">
              <span class="col-form-label">Geographic Coverage:</span>
              <div class="value">
                <div class="categoryWrapper">
                  <div class="category" *ngFor="let category of adverseMedia.categories;">
                    <div class="parent">
                      <span class="pi" [ngClass]="category.show ? 'pi-angle-down' : 'pi-angle-right'"
                        (click)="category.show=!category.show"></span>
                      {{category.description}}
                    </div>
                    <div *ngIf="category.show">
                      <div class="options" *ngFor="let option of category.options">
                        <input type="checkbox" class="custom" [checked]="option.selected" disabled>
                        {{option.description}}
                      </div>
                    </div>
                  </div>
                </div><!-- categoryWrapper -->
              </div>
            </div>

            <div class="form-group categoryControl">
              <span class="col-form-label">Event Types:</span>
              <div class="value">
                <div class="categoryWrapper">
                  <div class="category" *ngFor="let category of adverseMedia.eventTypes;">
                    <div class="parent">

                      <span class="pi" [ngClass]="category.show ? 'pi-angle-down' : 'pi-angle-right'"
                        (click)="category.show=!category.show"></span>
                      {{category.code}}
                    </div>
                    <div *ngIf="category.show">
                      <div class="options" *ngFor="let option of category.options">
                        <input type="checkbox" class="custom" [checked]="option.selected" disabled>
                        {{option.description}}
                      </div>
                    </div>
                  </div>
                </div><!-- categoryWrapper -->
              </div>
            </div>
            <div class="form-group categoryControl" *ngIf="adverseMedia?.subProducts?.length">
              <span class="col-form-label">Sub Categories: </span>
              <div class="value">
                <div class="subCategoryWrapper">
                  <div class="fieldWrapper" *ngFor="let choice of adverseMedia.subProducts; let i=index">
                    <input type="checkbox" class="custom" [checked]="choice.selected" disabled>
                    <span>
                      {{choice.description}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </p-tabPanel>
      <p-tabPanel header="User Data" >
        <div>
          <app-list-datasets (dataEvent)="handleJson($event)" [accountId]="accountId" [enrollmentId]="enrollmentId"></app-list-datasets>
        </div>
      </p-tabPanel>
    </p-tabView>
    <a routerLink="/" class="button submitButton">Back</a>
    <button class="button showHide" (click)="showAudit = !showAudit">{{ showAudit === true ? 'Hide' : 'Show' }} Audit
      Logs</button>
  </div>
  <div>
    <!-- <div class="topBarWrapper">
      <h2 class="heading-text">Audit Details</h2>
      <button class="button showHide" (click)="showAudit = !showAudit">Show/Hide</button>
    </div> -->
    <app-audit-trail [inputFilter]="filterObject" *ngIf="showAudit"></app-audit-trail>
  </div>
</div>


<p-dialog [(visible)]="displayDataset" [modal]="true" [style]="{width: '80vw'}" [header]="'User Dataset Details'">
    <app-view-datasets [datasetId]="selectedDatasetId"></app-view-datasets>
</p-dialog>

<p-dialog [(visible)]="createDataset" [modal]="true" [style]="{width: '80vw'}" [header]="'User Dataset Profile Setup'">
    <app-create-datasets [accountId]="accountId" [fileName]="selectedFileName"></app-create-datasets>
</p-dialog>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<p-dialog header="Add Source to Custom List" [(visible)]="displayAddSourceModal" [modal]="true" [style]="{width: '50vw'}">
    <div class="p-fluid">
        <div class="p-field">
            <label for="sourceId">Source ID: </label> 
            <input id="sourceId" type="text" pInputText [(ngModel)]="sourceIdToAdd">
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="submitAddSource()" label="Submit" styleClass="p-button-text"></p-button>
        <p-button icon="pi pi-times" (click)="displayAddSourceModal=false" label="Cancel"></p-button>
    </ng-template>
</p-dialog>